<template>
  <b-container flex class="mx-6">
    <b-row align-v="start" class="my-2" style="border-bottom: 2px solid grey">
      <b-col class="text-left">
        <b-row>
          <img class="card-img-top" src="../../assets/img_avatar.png" style="width:140px; height: auto; margin-bottom: 10px;" alt="Card image">
        </b-row>
        <b-row style="text-height: font-size 18px;">
          <strong>{{ user.name }} {{ user.surname }}</strong>
        </b-row>
      </b-col>
      <b-col class="text-left">
        <h3>Dati</h3>
        <b-row><span class="material-icons" style="vertical-align: middle;">email</span>
            {{ user.email }}
        </b-row>
        <b-row>
          <span class="material-icons" style="vertical-align: middle;">phone</span>
            {{ user.phone_nr }}
        </b-row>
        <b-row>
          <span class="material-icons" style="vertical-align: middle;">home</span>
            {{ user.address }}
          </b-row>
        <b-row style="margin-left: 20px; margin-top: -5px;">
          {{ user.postal_code }} - {{ user.city }} ({{ user.province }})
        </b-row>
        <b-row>
          <span class="material-icons" style="vertical-align: middle;">perm_identity</span>
            ({{ user.doc_type }}) {{ user.doc_nr }}
        </b-row>
        <b-row size="lg" class="my-3">
          <b-button size="md" @click="editUser($event.target)" class="mr-1">
            <span class="material-icons" style="vertical-align: middle;">edit</span>Modifica USER
          </b-button>
        </b-row>
      </b-col>
      <b-col class="text-left">
        <h3>CARD</h3>
        <b-row>
          <template v-if="card.active">
            <span class="material-icons" style="vertical-align: middle; color: success">verified_user</span>
          </template>
          <template v-else>
            <span class="material-icons" style="vertical-align: middle; color: alarm;">block</span>
          </template>
            {{ cardId }}
        </b-row>
        <b-row>
          Nr Items: {{ card.subsItems }}
        </b-row>
        <b-row size="lg" class="my-3">
          <b-button size="md" @click="editCard(cardId, $event.target)" class="mr-1">
            <span class="material-icons" style="vertical-align: middle;">edit</span>Modifica CARD
          </b-button>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button  size="lg" title="DOGs" class="mr-1" style="background-color: #AAA">
          DOGs
        </b-button>
        <b-button size="lg" title="crea DOG" class="ml-1" style="" @click="addDog($event.target)">
            +
          </b-button>
      </b-col>
      <b-col>
        <b-button  size="lg" title="SUBs" class="mr-1" style="background-color: #AAA">
          SUBs
        </b-button>
      </b-col>
    </b-row>
    <div class="scrollable">
      <table class="table table-bordered">
        <thead style="background-color: #333; color: #FFF">
          <th>CANE</th>
          <th>Taglia/pelo</th>
          <th>Pacchetto SELF</th>
          <th>Azioni</th>
        </thead>
        <tbody>
          <tr class="my-2" v-for="dog in userDogs" :key="dog.id"> 
            <td sm="2" style="vertical-align: middle">
              <tr>{{ dog.name }}</tr>
              <tr>{{ dog.breedName }}</tr>
            </td>
            <td sm="2" style="vertical-align: middle">Tg:{{ dog.size }} / pelo:{{ dog.hair }}</td>
            <td sm="6" style="vertical-align: middle">
              <tr v-for="sub in dog.subs" :key="sub.id" >
                <td style="border: none">{{ sub.name }} (x{{ sub.washTot }} lavaggi)</td>
                <td style="border: none">{{ sub.netPrice }} - {{ sub.exp_dt }}</td>
              </tr>
            </td>
            <td sm="2" style="vertical-align: middle">
              <b-button size="md" title="modifica DOG" class="ml-1" style="" @click="editDog(dog.id, dog, $event.target)">
                <span class="material-icons" style="vertical-align: middle;">edit</span>
                Modifica DOG
              </b-button>
              <b-button size="md" title="crea SUBs" class="ml-1" style="" @click="addSubs(dog.id, dog, $event.target)">
                +
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  <!-- Main Modal -->
    <b-modal :id="mainModal.id" 
      :title="mainModal.title" 
      size="xl" 
      ok-only
      ok-title="CHIUDI"
      ok-variant="secondary"
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
    >
      <template v-if="functionName=='editUser'">
        <UserEdit />
      </template>
      <template v-else-if="functionName=='editCard'">
        <CardEdit />
      </template>
      <template v-else-if="functionName=='addDog'">
        <DogCreate />
      </template>
      <template v-else-if="functionName=='editDog'">
        <DogEdit />
      </template>
      <template v-else-if="functionName=='addSubs'">
        <SubsCreate />
      </template>
    </b-modal>
  </b-container>
</template>

<script>
  import { db } from '../../firebase/config.js';
  import UserEdit from './UserEdit.vue';
  import CardEdit from '../cards/CardEdit.vue';
  import DogCreate from '../dogs/DogCreate.vue';
  import DogEdit from '../dogs/DogEdit.vue';
  import SubsCreate from '../subs/SubsCreate.vue';
  //import { cardData } from '../../interfaces/CardData';
  import { mapGetters, mapMutations } from 'vuex';
  
  export default {
    data() {
      return {
        search_surname: '',
        user: {
          name: '',
          surname: '',
          email: '',
          phone_prefix: '',
          phone_nr: '',
          address: '',
          postal_code: '',
          city: '',
          province: '',
          country: '',
          doc_type: '',
          doc_nr: ''
        },
        mainModal: {
          id: 'main-modal',
          title: '',
          content: '',
        },
        headerBgVariant: 'secondary',
        headerTextVariant: 'light',
        cardId: '',
        /*card: {
          active: '',
          userRef: '',
        },*/
        card: {},
        userDogs: [],
        dogSubs: [],
        functionName: ''
      }
    },
    created() {
      const userId = this.sel_user.data.id;
      console.log('userId: ' + userId);
      db.collection('users').doc(userId).onSnapshot((doc) => {
        this.user.key = doc.id;
        this.user = doc.data();
      })
      db.collection('cards').where('userRef', '==', userId)
      .get()
      .then((querySnapshot) => {

        if(querySnapshot.empty) {
          this.set_sel_card({uid: 'NO Card', data: {}});
          //Display error
          console.log('UserDetail - sel_card ->', this.sel_card);
          console.log("Error: NO Card for User: ", userId);
        } 
        else
        {
          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            this.cardId = doc.id;
            this.card = doc.data();
            this.set_sel_card({uid: doc.id, data: doc.data()});
            //Display success
            console.log('UserDetail - sel_card ->', this.sel_card);
            console.log(doc.id, " => ", doc.data());
          });
        }
        
      })
      .catch((error) => {
        //Display error
        console.log("Error getting documents: ", error);
      });
      this.getDogs(userId);
    },
    computed: {
      ...mapGetters({
        // map `this.sel_user` to `this.$store.getters._user`
        sel_user: "_user",
        // map `this.sel_dog` to `this.$store.getters._dog`
        sel_dog: "_dog",
        sel_subs: "_subs",
        sel_card: "_card",
      }),
    },
    mounted() {
    },
    methods: {
      editUser(button) {
        this.functionName = "editUser"
        this.mainModal.title = `Modifica USER`
        this.$root.$emit('bv::show::modal', this.mainModal.id, button)
        //this.$router.replace({name:'user_edit'}) //not working; try child view component
      },
      addDog(button) {
        this.functionName = "addDog"
        this.mainModal.title = `Crea DOG`
        this.$root.$emit('bv::show::modal', this.mainModal.id, button)
      },
      editDog(dogId, dogData, button) {
        this.functionName = "editDog"
        this.mainModal.title = `Modifica DOG`
        this.set_sel_dog({id: dogId, data: dogData});
        this.$root.$emit('bv::show::modal', this.mainModal.id, button)
      },
      editCard(cardId, button) {
        this.functionName = "editCard"
        this.mainModal.title = `Modifica CARD`
        //this.set_sel_dog({id: dogId, data: dogData});
        this.$root.$emit('bv::show::modal', this.mainModal.id, button)
      },
      addSubs(dogId, dogData, button) {
        this.functionName = "addSubs"
        this.mainModal.title = `Crea/rinnova SUBs`
        this.set_sel_dog({id: dogId, data: dogData})
        console.log('dogId ->', dogId)
        console.log('dogData ->', dogData)
        console.log('sel:dog ->', this.set_sel_dog)
        this.$root.$emit('bv::show::modal', this.mainModal.id, button)
      },
      getDogs(userId) {
        let dogsCollectionRef = db.doc(`users/${userId}`).collection('dogs')
        //dogsCollectionRef.get().then(snapshot => {
        dogsCollectionRef.onSnapshot((snapshot) => {
          this.isBusy = true
          this.userDogs = [];
          snapshot.forEach((doc) => {
            this.dogSubs = [];
            this.getSubs(doc.ref.path, this.dogSubs)
            console.log('dogSubs ->', this.dogSubs)
            let subsName = "nessun pacchetto SELF"
            let subsLenght = 0
            if (this.dogSubs.lenght > 0) {
              subsName = this.dogSubs[0].name
              subsLenght = this.dogSubs.lenght
            }

            this.userDogs.push({
              id: doc.id,
              name: doc.data().name,
              breedName: doc.data().breedName,
              size: doc.data().size,
              hair: doc.data().hair,
              washPgm: doc.data().washPgm,
              subsName: subsName,
              subsLenght: subsLenght,
              subs: this.dogSubs
            });
            console.log('userDogs ->', this.userDogs)
            this.isBusy = false
          })
        })
      },
      getSubs(dogRefPath, dogSubs) {
        let dogSubscriptions = dogSubs
        let subsCollectionRef = db.doc(dogRefPath).collection('subs')
        subsCollectionRef.orderBy('exp_dt', 'desc').get().then(snapshot => {
          snapshot.forEach((sub) => {
            dogSubscriptions.push({
              id: sub.id,
              active: sub.data().active,
              name: sub.data().name,
              //currency: sub.data().price.currency,
              //discountType: sub.data().price.discountType,
              discount: '€ ' + (sub.data().price.discount/100).toFixed(2),
              netPrice: '€ ' + (sub.data().price.net/100).toFixed(2),
              listPrice: '€ ' + (sub.data().price.list/100).toFixed(2),
              unitCost: '€ ' + (sub.data().price.unitCost/100).toFixed(2),
              exp_dt: sub.data().exp_dt.toDate().toLocaleDateString('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' }), // expiration date in string format => DD/MM/YYYY),
              washTot: sub.data().WashTot
            })
          })
          return dogSubscriptions;
        })
      },
      ...mapMutations({
            set_sel_user: 'SET_SEL_USER', // map `this.set_sel_user()` to `this.$store.commit('SET_SEL_USER')`
            set_sel_dog: 'SET_SEL_DOG',
            set_sel_card: 'SET_SEL_CARD',
      })
    },
    components: {
      UserEdit,
      CardEdit,
      DogCreate,
      DogEdit,
      SubsCreate
    }

  };
</script>
<!-- css at bottom of page -->
<style lang="scss" scoped>

.scrollable {
  max-width: 80vw;
  overflow-x: auto;
}
</style>